import heic2any from 'heic2any';

/**
 * Converts HEIC/HEIF image files to JPEG format.
 * This is necessary because most web browsers cannot display HEIC images,
 * which are the default format for photos taken on iPhones.
 *
 * @param file - The HEIC/HEIF file to convert
 * @returns A new File object in JPEG format
 */
export const convertHeicToJpeg = async (file: File): Promise<File> => {
  try {
    const blob = await heic2any({
      blob: file,
      toType: 'image/jpeg',
      quality: 0.85,
    });

    // heic2any can return a single blob or array of blobs
    const resultBlob = Array.isArray(blob) ? blob[0] : blob;

    // Create new File with .jpg extension
    const newFileName = file.name.replace(/\.(heic|heif)$/i, '.jpg');
    return new File([resultBlob], newFileName, {type: 'image/jpeg'});
  } catch (error) {
    console.error('Failed to convert HEIC to JPEG:', error);
    throw error;
  }
};

/**
 * @deprecated Use convertHeicToJpeg instead
 */
export const convertToPng = async (file: File) => {
  return convertHeicToJpeg(file);
};
